import React from "react"
import { Controller, Control } from "react-hook-form"

export interface FormInputProps {
  name: string
  control: Control
  value?: string
  checked?: boolean
  required?: boolean
  disabled?: boolean
}

const FormInputLightswitch = ({
  control,
  name,
  checked,
  required,
  disabled,
}: FormInputProps) => {
  const wrapperClass = `c-form__checkbox-lightswitch`

  return (
    <div className={wrapperClass}>
      <Controller
        name={name}
        render={({ field: { onChange, value } }) => {
          return (
            <input
              className="c-form__lightswitch__input"
              type="checkbox"
              name={name}
              id={name + value}
              checked={checked}
              disabled={disabled}
              onChange={onChange}
              value={value}
              required={required}
            />
          )
        }}
        control={control}
      />
    </div>
  )
}

export default FormInputLightswitch
